// src/pages/RegistrationPage/RegisterPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import {
//     Box,
//     Button,
//     Stack,
//     TextField,
//     MenuItem,
//     Select,
//     InputLabel,
//     FormControl,
//     Checkbox,
//     ListItemText,
//     OutlinedInput
// } from '@mui/material';
// import block from 'bem-cn';
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { observer } from "mobx-react";
import styles from "./styles.module.scss";
import RegRight from "assets/images/reg_right.png";
import { Lisense } from "./lisense/Lisense";
import { authStore } from "stores";
import { Loader } from "components";
import { RouterPathEnum } from "shared/enums/commonEnums";
import "./RegisterPage.scss";
import { Button } from "components/frontComponents/button/Button";
import { NotScrollJournalPage } from "components/frontComponents/notScrollJournalPage/NotScrollJournalPage";
import Key from "assets/images/registration/key.png";
import TopLeft from "assets/images/registration/topLeft.png";
import BottomLeft from "assets/images/registration/bottomLeft.png";
import Bubble1920 from "assets/images/registration/bubble1920.png";
import Bubble1440 from "assets/images/registration/bubble1440.png";
import Pink1440 from "assets/images/registration/pink1440.png";
import Pink from "assets/images/registration/pink.png";
import Right1440 from "assets/images/registration/right1440.png";
import BottomLeft1440 from "assets/images/registration/bottomLeft1440.png";
import TopLeft1440 from "assets/images/registration/topLeft1440.png";
import Right from "assets/images/registration/right.png";
import Bcg from "assets/images/registration/bcg.png";
import TopBubble from "assets/images/registration/topBubble.png";
import TopBubble1440 from "assets/images/registration/topBubble1440.png";
import TopBubble768 from "assets/images/registration/topBubble768.png";
// const cnRegisterPage = block('RegisterPage');

const healthOptions = [
  { key: "HypertensionStage1", label: "Гипертония 1 стадии" },
  { key: "HypertensionStage2", label: "Гипертония 2 стадии" },
  { key: "CardiacHistory", label: "Перенесённый инфаркт/инсульт" },
  { key: "Arrhythmia", label: "Аритмия" },
  { key: "AsthmaMild", label: "Астма (лёгкая)" },
  { key: "AsthmaModerate", label: "Астма (средняя/тяжёлая)" },
  { key: "Epilepsy", label: "Эпилепсия" },
  { key: "VertigoOrBalance", label: "Головокружения / нарушения равновесия" },
  { key: "SpineIssues", label: "Проблемы с позвоночником" },
  { key: "JointDisorders", label: "Заболевания суставов" },
  { key: "RecentSurgery", label: "Недавняя операция" },
  { key: "RecentInjury", label: "Недавняя травма" },
  { key: "Osteoporosis", label: "Остеопороз" },
  { key: "HerniaOrProtrusion", label: "Грыжа или протрузия" },
  { key: "Obesity", label: "Ожирение (ИМТ > 30)" },
  { key: "DiabetesType1", label: "Диабет 1 типа" },
  { key: "DiabetesType2", label: "Диабет 2 типа" },
  { key: "FatigueSyndrome", label: "Хроническая усталость" },
  { key: "AnxietyOrPanic", label: "Тревожность / панические состояния" },
  { key: "VisualSensitivity", label: "Светочувствительность" },
  { key: "SkinAllergy", label: "Аллергия на материалы" },
  { key: "Photosensitivity", label: "Фоточувствительность" },
];

const genderOptions = [
  { key: "male", label: "М" },
  { key: "female", label: "Ж" },
];

const handOptions = [
  { key: "right", label: "Правая" },
  { key: "left", label: "Левая" },
];

const activityOptions = [
  { key: "low", label: "Низкая" },
  { key: "medium", label: "Средняя" },
  { key: "high", label: "Высокая" },
];

const RegisterPage = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [gender, setGender] = useState("male");
  const [height, setHeight] = useState<number | "">("");
  const [weight, setWeight] = useState<number | "">("");
  const [dominantHand, setDominantHand] = useState("right");
  const [activityLevel, setActivityLevel] = useState("medium");
  const [healthLimitations, setHealthLimitations] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  //   const [formVisible, setFormVisible] = useState(false);

  //   useEffect(() => {
  //     const timeout = setTimeout(() => setFormVisible(true), 50); // плавное появление
  //     return () => clearTimeout(timeout);
  //   }, []);
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    maxHeight: "60vh", // 60% от высоты экрана
    overflow: "auto",
    mt: 2,
    pr: 1, // отступ для скроллбара
  };
  // Закрытие модального окна
  const handleCloseModal = () => {
    setModalOpen(false);
  };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    setHealthLimitations((prev) => {
      // Добавляем значение, если чекбокс отмечен, иначе фильтруем его из массива
      return isChecked
        ? [...prev, value]
        : prev.filter((item) => item !== value);
    });
  };

  const handleRegister = async () => {
    if (password !== confirmPassword) {
      setError("Пароли не совпадают");
      return;
    }
    setError(null);
    console.log(error);
    // Преобразуем дату в dd-mm-yyyy
    let formattedBirthDate = "";
    if (birthDate) {
      const [year, month, day] = birthDate.split("-"); // YYYY-MM-DD
      formattedBirthDate = `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    }

    const payload = {
      username,
      password,
      email,
      birthDate: formattedBirthDate,
      gender,
      height: typeof height === "number" ? height : 0,
      weight: typeof weight === "number" ? weight : 0,
      dominantHand,
      activityLevel,
      healthLimitations,
      role: "user",
    };

    console.log("Отправляем дату рождения на сервер:", formattedBirthDate);
    console.log("Регистрация пользователя:", username);

    try {
      await authStore.register(payload);

      if (!authStore.error) {
        // Уведомление об успехе через state вместо alert
        setError(null);

        // 🔹 Перенаправление на страницу логина
        navigate(RouterPathEnum.Auth);
      } else {
        setError(authStore.error);
      }
    } catch (err: any) {
      console.error("Ошибка регистрации:", err);
      setError(err?.message || "Ошибка регистрации");
    }
  };

  if (authStore.isLoading) return <Loader visible />;

  return (
    // <Box className={cnRegisterPage.toString()}>
    //   {formVisible && (
    //     <Stack
    //       className={cnRegisterPage('form').toString()}
    //       direction="column"
    //       gap={3}
    //       padding={4}
    //       borderRadius={2}
    //       maxWidth={400}
    //       margin="auto"
    //     >
    //       <h2 style={{ textAlign: 'center' }}>Регистрация</h2>

    //       <TextField
    //         label="Логин"
    //         value={username}
    //         onChange={(e) => setUsername(e.target.value)}
    //         fullWidth
    //       />
    //       <TextField
    //         label="Пароль"
    //         type="password"
    //         value={password}
    //         onChange={(e) => setPassword(e.target.value)}
    //         fullWidth
    //       />
    //       <TextField
    //         label="Подтверждение пароля"
    //         type="password"
    //         value={confirmPassword}
    //         onChange={(e) => setConfirmPassword(e.target.value)}
    //         fullWidth
    //       />
    //       <TextField
    //         label="Email"
    //         type="email"
    //         value={email}
    //         onChange={(e) => setEmail(e.target.value)}
    //         fullWidth
    //       />
    //       <TextField
    //         label="Дата рождения"
    //         type="date"
    //         value={birthDate}
    //         onChange={(e) => setBirthDate(e.target.value)}
    //         InputLabelProps={{ shrink: true }}
    //         fullWidth
    //       />

    //       <FormControl fullWidth>
    //         <InputLabel>Пол</InputLabel>
    //         <Select value={gender} onChange={(e) => setGender(e.target.value)}>
    //           {genderOptions.map((opt) => (
    //             <MenuItem key={opt.key} value={opt.key}>
    //               {opt.label}
    //             </MenuItem>
    //           ))}
    //         </Select>
    //       </FormControl>

    //       <TextField
    //         label="Рост (см)"
    //         type="number"
    //         value={height}
    //         onChange={(e) => setHeight(e.target.value ? Number(e.target.value) : '')}
    //         fullWidth
    //       />
    //       <TextField
    //         label="Вес (кг)"
    //         type="number"
    //         value={weight}
    //         onChange={(e) => setWeight(e.target.value ? Number(e.target.value) : '')}
    //         fullWidth
    //       />

    //   <FormControl fullWidth>
    //     <InputLabel>Доминирующая рука</InputLabel>
    //     <Select value={dominantHand} onChange={(e) => setDominantHand(e.target.value)}>
    //       {handOptions.map((opt) => (
    //         <MenuItem key={opt.key} value={opt.key}>
    //           {opt.label}
    //         </MenuItem>
    //       ))}
    //     </Select>
    //   </FormControl>

    //       <FormControl fullWidth>
    //         <InputLabel>Уровень активности</InputLabel>
    //         <Select value={activityLevel} onChange={(e) => setActivityLevel(e.target.value)}>
    //           {activityOptions.map((opt) => (
    //             <MenuItem key={opt.key} value={opt.key}>
    //               {opt.label}
    //             </MenuItem>
    //           ))}
    //         </Select>
    //       </FormControl>

    //       <FormControl fullWidth>
    //         <InputLabel>Противопоказания</InputLabel>
    //         <Select
    //           multiple
    //           value={healthLimitations}
    //           onChange={(e) => {
    //             const value = e.target.value;
    //             setHealthLimitations(typeof value === 'string' ? value.split(',') : value);
    //           }}
    //           input={<OutlinedInput label="Противопоказания" />}
    //           renderValue={(selected) => {
    //             const selectedLabels = healthOptions
    //               .filter((opt) => selected.includes(opt.key))
    //               .map((opt) => opt.label);
    //             return selectedLabels.length ? `Выбрано: ${selectedLabels.length}` : 'Выберите';
    //           }}
    //         >
    //           {healthOptions.map((opt) => (
    //             <MenuItem key={opt.key} value={opt.key}>
    //               <Checkbox checked={healthLimitations.indexOf(opt.key) > -1} />
    //               <ListItemText primary={opt.label} />
    //             </MenuItem>
    //           ))}
    //         </Select>
    //       </FormControl>

    //       {error && <div className="err">{error}</div>}

    //       <Button variant="contained" onClick={handleRegister}>
    //         Зарегистрироваться
    //       </Button>
    //     </Stack>
    //   )}
    // </Box>
    <section className={styles.registrationPage}>
      <div className={styles.registration}>
        <NotScrollJournalPage
          leftContent={
            <div className={styles.containerLeft}>
              <div className={styles.registrationLeft}>
                <div className={styles.registrationList}>
                  <div className={styles.title}>Регистрация</div>
                  <form className={styles.formLeft}>
                    <div className={styles.inputHolder}>
                      <label className={styles.label}>
                        <p className={styles.inputlegend}>
                          Ваш будущий позывной*:
                        </p>
                        <div className={styles.inputfake}>
                          <input
                            className={styles.inputcontrol}
                            type="text"
                            name="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Выберите имя проводника"
                          />
                        </div>
                      </label>
                    </div>
                    <div className={styles.inputHolder}>
                      <label className={styles.label}>
                        <p className={styles.inputlegend}>
                          Новый эфирный ключ*:
                        </p>
                        <div className={styles.inputfake}>
                          <input
                            className={styles.inputcontrol}
                            type="password"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Создайте код доступа"
                          />
                        </div>
                      </label>
                    </div>
                    <div className={styles.inputHolder}>
                      <label className={styles.label}>
                        <p className={styles.inputlegend}>Подтвердите ключ*:</p>
                        <div className={styles.inputfake}>
                          <input
                            className={styles.inputcontrol}
                            type="password"
                            name="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Подтвердите код доступа"
                          />
                        </div>
                      </label>
                    </div>
                    <div className={styles.inputHolder}>
                      <label className={styles.label}>
                        <p className={styles.inputlegend}>Эфирная почта*:</p>
                        <div className={styles.inputfake}>
                          <input
                            className={styles.inputcontrol}
                            type="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Для связи между мирами"
                          />
                        </div>
                      </label>
                    </div>
                    <div className={styles.inputHolder}>
                      <label className={styles.label}>
                        <p className={styles.inputlegend}>Дата рождения*:</p>
                        <div className={styles.inputfake}>
                          <input
                            className={styles.inputcontrol}
                            type="date"
                            name="date"
                            value={birthDate}
                            onChange={(e) => setBirthDate(e.target.value)}
                            placeholder="дд/мм/гг"
                          />
                        </div>
                      </label>
                    </div>
                    <div className={styles.inputHolder}>
                      <label className={styles.label}>
                        <div className={styles.gender}>
                          <p className={styles.inputlegendRadio}>Пол*:</p>
                          <div className={styles.inputfakeRadio}>
                            {genderOptions.map((opt) => (
                              <div className={styles.checkboxholder}>
                                <div className={styles.inputlegendRadio}>
                                  {opt.label}
                                </div>
                                <input
                                  className={styles.inputcheckboxcontrol}
                                  type="radio"
                                  name="gender"
                                  checked={gender === opt.key}
                                  onChange={() => setGender(opt.key)}
                                  value={opt.key}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </label>
                    </div>

                    <div className={styles.inputHolder}>
                      <label className={styles.label}>
                        <p className={styles.inputlegend}>Рост:</p>
                        <div className={styles.inputfake}>
                          <input
                            className={styles.inputcontrol}
                            type="number"
                            name="height"
                            value={height}
                            onChange={(e) =>
                              setHeight(
                                e.target.value ? Number(e.target.value) : ""
                              )
                            }
                            placeholder="Рост(м)"
                          />
                        </div>
                      </label>
                    </div>
                    <div className={styles.inputHolder}>
                      <label className={styles.label}>
                        <p className={styles.inputlegend}>Вес:</p>
                        <div className={styles.inputfake}>
                          <input
                            className={styles.inputcontrol}
                            type="number"
                            name="weight"
                            value={weight}
                            onChange={(e) =>
                              setWeight(
                                e.target.value ? Number(e.target.value) : ""
                              )
                            }
                            placeholder="Вес(кг)"
                          />
                        </div>
                      </label>
                    </div>

                    <div className={styles.inputHolder}>
                      <label className={styles.label}>
                        <p className={styles.inputlegend}>Доминирующая рука:</p>
                        <div className={styles.inputfakeRadio}>
                          {handOptions.map((opt) => (
                            <div
                              className={styles.checkboxholder}
                              key={opt.key}
                            >
                              <div className={styles.inputlegendRadio}>
                                {opt.label}
                              </div>
                              <input
                                className={styles.inputcheckboxcontrol}
                                type="radio"
                                name="hand"
                                value={opt.key}
                                checked={dominantHand === opt.key}
                                onChange={(e) =>
                                  setDominantHand(e.target.value)
                                }
                              />
                            </div>
                          ))}
                        </div>
                      </label>
                    </div>

                    <div className={styles.inputHolder}>
                      <label className={styles.label}>
                        <p className={styles.inputlegend}>
                          Уровень активности:
                        </p>
                        <select
                          id="actvity"
                          name="activity"
                          className={styles.selectfake}
                          value={activityLevel}
                          onChange={(e) => setActivityLevel(e.target.value)}
                        >
                          {activityOptions.map((opt) => (
                            <option value={opt.key}>{opt.label}</option>
                          ))}
                        </select>
                      </label>
                    </div>
                  </form>
                </div>
                <div className={styles.keyholder}>
                  <img src={Key} alt="" className={styles.key} />
                </div>
              </div>
              <div className={styles.registrationRight}>
                <div className={styles.topRightLeft}>
                  {/* <picture>
                    <source media="(min-width: 1620px)" srcSet={TopBubble} />

                    <img
                      src={TopBubble1440}
                      className={styles.topbubble}
                      alt=""
                      loading="lazy"
                    />
                  </picture> */}
                  <div className={styles.topbubble}>
                    <img
                      src={TopBubble}
                      className={styles.topbubblepicture}
                      alt="fullfilProfile"
                      loading="lazy"
                    />
                  </div>
                </div>
                {/* <picture>
                  <source media="(min-width: 1620px)" srcSet={TopLeft} />
                  <img
                    src={TopLeft1440}
                    className={styles.photo}
                    alt=""
                    loading="lazy"
                  />
                </picture> */}
                <div className={styles.instruction}>
                  {" "}
                  для базового уровня доступа заполни поля, помеченные символом
                  *
                </div>
                <div className={styles.bottompictureholder}>
                  {/* <picture>
                    <source media="(min-width: 1620px)" srcSet={BottomLeft} />
                    <img
                      src={BottomLeft1440}
                      className={styles.photo}
                      alt=""
                      loading="lazy"
                    />
                  </picture> */}
                  <img
                    src={BottomLeft}
                    className={styles.photo}
                    alt=""
                    loading="lazy"
                  />
                  {/* <picture>
                    <source media="(min-width: 1620px)" srcSet={Bubble1920} />
                    <img
                      src={Bubble1440}
                      className={styles.bubble}
                      alt=""
                      loading="lazy"
                    />
                  </picture> */}
                  <div className={styles.bubble}>
                    <img
                      src={Bubble1440}
                      className={styles.photo}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          }
          rightContent={
            <div className={styles.containerRight}>
              {/* <img src={RegRight} className={styles.left} alt="" /> */}
              <div className={styles.registrationListRight}>
                <h3 className={styles.registrationTitle}>Ограничения</h3>
                <form className={styles.formRight}>
                  {healthOptions.map((option) => (
                    <div className={styles.inputHolder} key={option.key}>
                      <label className={styles.label}>
                        <div className={styles.inputfakeRight}>
                          <input
                            className={styles.inputcheckboxcontrolRight}
                            type="checkbox"
                            name="diseases"
                            value={option.key}
                            checked={healthLimitations.includes(option.key)} // Управляем состоянием
                            onChange={handleCheckboxChange} // Подключаем обработчик
                          />
                          <span className={styles.customCheckbox}></span>
                          <p className={styles.inputlegendRight}>
                            {option.label}
                          </p>
                        </div>
                      </label>
                    </div>
                  ))}
                </form>
              </div>
              <div className={styles.photosRight}>
                <picture>
                  <source media="(min-width: 1620px)" srcSet={Right} />
                  <img
                    src={Right1440}
                    className={styles.photo1}
                    alt=""
                    loading="lazy"
                  />
                </picture>
                <div className={styles.pinkholder}>
                  {/* <img src={Bcg} alt="" className={styles.pinkbcg} /> */}
                  <picture>
                    <source media="(min-width: 1620px)" srcSet={Pink} />
                    <img
                      src={Pink1440}
                      className={styles.pink}
                      alt=""
                      loading="lazy"
                    />
                  </picture>
                </div>
              </div>
              {/* <Lisense /> */}
              <form className={styles.formlisense1}>
                <div className={styles.inputHolder}>
                  <label className={styles.label}>
                    <div className={styles.inputfakeLisense}>
                      <input
                        className={styles.inputcheckboxcontrolRight}
                        type="checkbox"
                        name="lisense"
                        onChange={handleCheckboxChange}
                      />
                      <span className={styles.customCheckbox}></span>
                      <p className={styles.inputlegendLisense}>
                        Ставя галочку, вы соглашаетесь с условиями{" "}
                        <button
                          type="button"
                          onClick={() => setModalOpen(true)}
                          style={{
                            background: "none",
                            border: "none",
                            color: "white",
                            cursor: "pointer",
                            textDecoration: "underline",
                            padding: 0,
                            margin: 0,
                            font: "inherit",
                            display: "inline",
                            zIndex: 100,
                          }}
                        >
                          лицензионного соглашения
                        </button>
                      </p>
                      <Modal
                        open={modalOpen}
                        onClose={() => setModalOpen(false)}
                      >
                        <Box sx={modalStyle}>
                          <IconButton
                            aria-label="close"
                            onClick={handleCloseModal}
                            sx={{
                              position: "sticky",
                              top: 0,
                              right: 0,
                              float: "right", // Выравниваем вправо
                              ml: 2, // Отступ слева от текста
                              mb: 2, // Отступ снизу для разделения с контентом
                              zIndex: 10,
                              bgcolor: "background.paper", // Фон, чтобы текст не просвечивал
                              "&:hover": {
                                bgcolor: "action.hover",
                              },
                            }}
                          >
                            <CloseIcon />
                          </IconButton>

                          <Typography variant="h6" component="h2">
                            Лицензионное соглашение
                          </Typography>

                          <Typography sx={{ mt: 2 }}>
                            1. Предмет соглашения 1.1. Предметом настоящего
                            соглашения является передача Правообладателем
                            конечному Пользователю неисключительного права на
                            использование ПО. ДАННОЕ СОГЛАШЕНИЕ НЕ ЯВЛЯЕТСЯ
                            СОГЛАШЕНИЕМ О ПРОДАЖЕ. Все условия, оговоренные
                            далее, относятся как к ПО в целом, так и ко всем его
                            компонентам в отдельности. Данное соглашение не
                            передает Вам права на программное обеспечение, а
                            лишь предоставляет ограниченное право на
                            использование, которое подлежит отмене согласно
                            условиям данного соглашения. Ничего в данном
                            соглашении не подтверждает отказ компании от прав на
                            интеллектуальную собственность по какому бы то ни
                            было законодательству. 1.2. Компания сохраняет за
                            собой все права, явным образом не предоставленные
                            Вам настоящим лицензионным договором. Настоящий
                            лицензионный договор не предоставляет Вам никаких
                            прав на товарные знаки компании . 1.3. В случае,
                            если Вы являетесь физическим лицом, то территория,
                            на которой допускается использование ПО, включает в
                            себя весь мир. В случае, если Вы являетесь
                            юридическим лицом (обособленным подразделением
                            юридического лица), то территория, на которой
                            допускается приобретение ПО, ограничена страной
                            регистрации юридического лица (обособленного
                            подразделения юридического лица), если только иное
                            не оговорено в отдельном письменном договоре между
                            Вами и Компанией 2. Имущественные права 2.1.
                            Программное обеспечение, включая все переработки,
                            исправления, модификации, дополнения, обновления
                            и/или усовершенствования к нему (далее по всему
                            тексту и любой его части определяемое как
                            "Программное обеспечение"), и связанная с ним
                            документация предназначается НЕ ДЛЯ ПРОДАЖИ и
                            является и остается исключительной собственностью
                            компании Все права на интеллектуальную собственность
                            (включая, без ограничений, авторские права,
                            коммерческую тайну, товарные знаки, и т.д.),
                            подтвержденные или включенные в
                            приложенные/взаимосвязанные/имеющие отношение к
                            данному руководству, данные, содержащиеся в нём, а
                            также все права на ПО являются и будут являться
                            собственностью исключительно компании 2.2. Вам,
                            конечному Пользователю, предоставляется
                            неисключительное право на использование ПО в
                            указанных в документации целях и при соблюдении
                            приведенных ниже условий. 3. Условия использования
                            3.1. ПО может быть использовано только в строгом
                            соответствии с документами, инструкциями и
                            рекомендациями Правообладателя, относящимися к
                            данному ПО. 3.2. ПО может предоставляться на
                            нескольких носителях, в том числе с помощью сети
                            интернет. Независимо от количества носителей, на
                            которых Вы получили ПО, Вы имеете право использовать
                            ПО только в объеме предоставленной Вам Лицензии.
                            3.3. После уплаты Вами соответствующего
                            вознаграждения компания настоящим предоставляет Вам,
                            а Вы получаете индивидуальное, неисключительное и
                            ограниченное право на использование данного
                            Программного обеспечения только в форме исполняемого
                            кода, как описано в прилагаемой к Программному
                            обеспечению документации и только в соответствии с
                            условиями данного Соглашения: • Вы можете установить
                            Программное обеспечение и использовать его
                            компьютерах, расположенных в пределах Вашего
                            предприятия, как описано в соответствующей
                            документации компании • Вы можете
                            добавить/присоединить Программное обеспечение к
                            программам Вашего компьютера с единственной целью,
                            описанной в данном Соглашении. • Продукт должен
                            использоваться и обслуживаться строго в соответствии
                            с описаниями и инструкциями компании , приведенными
                            в данном и других документах компании 3.4. За
                            исключением указанных выше разрешений, Вы
                            обязуетесь: 3.4.1. Не использовать и не выдавать
                            сублицензии на данное Программное обеспечение и
                            любую другую Продукцию компании , за исключением
                            явных разрешений в данном Соглашении и в Руководстве
                            по интеграции. 3.4.2. Не продавать, не выдавать
                            лицензий или сублицензий, не сдавать в аренду или в
                            прокат, не передавать, не переводить на другие
                            языки, не закладывать, не разделять Ваши права в
                            рамках данного Соглашения с кем-либо или кому-либо
                            ещё. 3.4.3. Не модифицировать (в том числе не
                            вносить в ПО изменения в целях его функционирования
                            на технических средствах Конечного пользователя), не
                            демонтировать, не декомпилировать или
                            дизассемблировать, не реконструировать, не
                            видоизменять и не расширять данное Программное
                            обеспечение и не пытаться раскрыть (получить)
                            исходные коды данного Программного обеспечения.
                            3.4.4. Не помещать данное Программное обеспечение на
                            сервер с возможностью доступа к нему третьих лиц
                            через открытую сеть. 3.4.5. Не использовать какие бы
                            то ни было резервные или архивные копии данного
                            Программного обеспечения (или позволять кому-либо
                            ещё использовать такие копии) с любой иной целью,
                            кроме замены его оригинального экземпляра в случае
                            его разрушения или наличия дефектов. 3.4.6. Не
                            пытаться обойти технические ограничения в Программе;
                            3.4.7. Не использовать Программу для оказания услуг
                            на платной и бесплатной основе; 3.4.8. Не создавать
                            условия для использования ПО лицами, не имеющими
                            прав на использование ПО, в том числе работающими с
                            Вами в одной многопользовательской системе или сети
                            Интернет. 3.4.9. Вы не вправе удалять, изменять или
                            делать малозаметными любые уведомления об авторских
                            правах, правах на товарные знаки или патенты,
                            которые указаны на/в ПО. 3.4.10. Вы обязуетесь
                            соблюдать права третьих лиц, в том числе авторские
                            права на объекты интеллектуальной собственности.
                            3.5. Компания Аладдин Р.Д. не несет обязательств по
                            предоставлению поддержки, обслуживания, модификации
                            или выходу новых релизов данного Программного
                            обеспечения. Нелегальное использование,
                            распространение и воспроизведение (копирование)
                            программного обеспечения является нарушением
                            действующего законодательства и преследуется по
                            Закону. В случае нарушения настоящего Соглашения
                            Правообладатель лишает Пользователя права на
                            использование ПО. При этом Правообладатель полностью
                            отказывается от своих гарантийных обязательств. 4.
                            Ограниченная гарантия. Компания гарантирует, что:
                            Данное Программное обеспечение с момента поставки
                            его Вам в течение двенадцати (12) месяцев будет
                            функционировать в полном соответствии с Руководством
                            Пользователя (Администратора), при условии, что оно
                            будет использоваться на компьютерном аппаратном
                            обеспечении и с операционной системой, для которой
                            оно было разработано. Правообладатель гарантирует
                            соответствие компонентов ПО спецификациям, а также
                            работоспособность ПО при выполнении Пользователем
                            условий, оговоренных в документации на ПО. ПО
                            поставляется "таким, какое оно есть".
                            Правообладатель не гарантирует, что ПО соответствует
                            вашим требованиям, и что все действия ПО будут
                            выполняться безошибочно. Правообладатель не
                            гарантирует корректную совместную работу ПО с
                            программным обеспечением или оборудованием других
                            производителей. 5. Отказ от гарантии. 5.1. Компания
                            «» не гарантирует, что любой из его продуктов будет
                            соответствовать вашим требованиям, или что его
                            работа будет бесперебойной или безошибочной. В
                            объеме, предусмотренном законодательством РФ,
                            компания «Аладдин Р.Д.» открыто отказывается от всех
                            гарантий, не оговоренных здесь, от всех
                            подразумеваемых гарантий, включая гарантию товарного
                            вида и пригодности использования для определённой
                            цели. Ни один из дилеров, дистрибьюторов, продавцов,
                            агентов или сотрудников компании «» не уполномочен
                            производить модификации, расширения или дополнения к
                            данной гарантии. 5.2. Если Вы произвели какие-либо
                            модификации Программного обеспечения или любой из
                            частей данного Продукта во время гарантийного
                            периода, то гарантия, упомянутая выше, будет
                            немедленно прекращена. 5.3. Гарантия
                            недействительна, если Продукт используется на или в
                            сочетании с иным аппаратным и/или программным
                            обеспечением, отличным от описанных в документации,
                            или используется на компьютере с любым установленным
                            нелицензионным программным обеспечением. 5.4. ПО и
                            обновления предоставляются такими, каковы они есть,
                            и Компания не предоставляет на них никаких гарантий.
                            Компания не гарантирует и не может гарантировать
                            работоспособность ПО и результаты, которые Вы можете
                            получить, используя ПО. 5.5. За исключением гарантий
                            и условий, которые не могут быть исключены или
                            ограничены в соответствии с применимым
                            законодательством, Компания не предоставляет Вам
                            никаких гарантий (в том числе явно выраженных или
                            подразумевающихся в статутном или общем праве или
                            обычаями делового оборота) ни на что, включая, без
                            ограничения, гарантии о не нарушении прав третьих
                            лиц, товарной пригодности, интегрируемости,
                            удовлетворительного качества и годности к
                            использованию ПО. Все риски, связанные с качеством
                            работы и работоспособностью ПО, возлагаются на Вас.
                            5.6. Компания не предоставляет никаких гарантий
                            относительно программ для ЭВМ других производителей,
                            которые могут предоставляться в составе ПО. 6.
                            Исключение косвенных убытков. Стороны признают, что
                            Продукт по сути своей сложный и не может быть
                            полностью лишен ошибок. Компания «» не несёт
                            ответственности (как в силу договора, гражданского
                            правонарушения, включая халатность, так и в любой
                            иной форме) перед вами или любой третьей стороной за
                            любые потери или убытки (включая косвенные,
                            фактические, побочные или потенциальные убытки),
                            включая, без ограничений, любые потери или убытки
                            прибыльности бизнеса, потерю доходности или
                            репутации, утраченную или искаженную информацию или
                            документацию вследствие какого-либо использования
                            данного программного обеспечения и/или любой
                            компоненты данного продукта, даже если письменно
                            уведомлён о возможности подобных убытков. 7.
                            Ограничение ответственности. В случае если, несмотря
                            на условия данного соглашения, компания признана
                            ответственной за убытки на основании каких-либо
                            дефектов или несоответствия его продуктов, полная
                            ответственность за каждую единицу дефектных
                            продуктов не будет превышать сумму, выплаченную
                            компании за эти дефектные продукты. Компания ни при
                            каких обстоятельствах не несет перед Вами никакой
                            ответственности за убытки, вынужденные перерывы в
                            деловой активности, потерю деловых либо иных данных
                            или информации, претензии или расходы, реальный
                            ущерб, а также упущенную выгоду и утерянные
                            сбережения, вызванные использованием или связанные с
                            использованием ПО, а также за убытки, вызванные
                            возможными ошибками и опечатками в ПО и/или в
                            документации, даже если Компании стало известно о
                            возможности таких убытков, потерь, претензий или
                            расходов, равно как и за любые претензии со стороны
                            третьих лиц. Вышеперечисленные ограничения и
                            исключения действуют в той степени, насколько это
                            разрешено применимым законодательством. Единственная
                            ответственность Компании по настоящему Лицензионному
                            договору ограничивается суммой, которую Вы уплатили
                            за ПО. 8. Прекращение действия. В случае
                            невыполнения Вами условий данного Соглашения
                            действие Вашей лицензии и настоящего Соглашения
                            будет прекращено. После прекращения действия данного
                            Лицензионного соглашения: (i) Лицензия,
                            предоставленная Вам данным Соглашением, прекращает
                            свое действие, и Вы после ее прекращения не сможете
                            продолжать дальнейшее использование данного
                            Программного обеспечения и других лицензионных
                            Продуктов; (ii) Вы незамедлительно вернёте в
                            компанию всё имущество, в котором используются права
                            на интеллектуальную собственность и все копии
                            такового и/или сотрёте/удалите любую информацию,
                            содержащуюся в них в электронном виде. Разделы 1, 3,
                            6-11 будут продолжать действовать даже в случае
                            прекращения действия настоящего Соглашения. 9. Срок
                            действия Договора 9.1. Если иное не оговорено в
                            настоящем Лицензионном договоре либо в отдельном
                            письменном договоре между Вами и Компанией ,
                            настоящий Лицензионный договор действует в течение
                            всего срока действия исключительного права на ПО.
                            9.2. В случае нарушения вами условий настоящего
                            Соглашения или неспособности далее выполнять его
                            условия вы обязуетесь уничтожить все копии ПО
                            (включая архивные, файлы с информацией, носители,
                            печатные материалы) или вернуть все относящиеся к ПО
                            материалы организации, в которой вы приобрели ПО.
                            После этого Соглашение прекращает свое действие.
                            9.3. Без ущерба для каких-либо других прав Компания
                            имеет право в одностороннем порядке расторгнуть
                            настоящий Лицензионный договор при несоблюдении Вами
                            его условий и ограничений. При прекращении действия
                            настоящего Лицензионного договора Вы обязаны
                            уничтожить все имеющиеся у Вас копии ПО (включая
                            архивные, файлы с информацией, носители, печатные
                            материалы), все компоненты ПО, а также удалить ПО и
                            вернуть все относящиеся к ПО материалы организации,
                            в которой вы приобрели ПО. 9.4. Вы можете
                            расторгнуть настоящий Лицензионный договор удалив ПО
                            и уничтожив все копии ПО, все компоненты ПО и
                            сопровождающую его документацию. Такое расторжение
                            не освобождает Вас от обязательств оплатить ПО. 10.
                            Применимое законодательство. Данное Соглашение
                            должно быть истолковано и определено в соответствии
                            с законами Российской Федерации (за исключением
                            конфликта применения правовых норм), и только
                            российский суд уполномочен осуществлять правосудие в
                            любых конфликтах и спорах, вытекающих из данного
                            Соглашения. Применение Конвенции Организации
                            Объединённых Наций о Договорах международной
                            купли-продажи товаров (the United Nations Convention
                            of Contracts for the International Sale of Goods)
                            однозначно исключается. Невозможность для любой из
                            сторон воспользоваться любым из прав,
                            предоставленных ей по данному Соглашению, или
                            принять меры против другой стороны в случае любого
                            нарушения своих обязательств по Соглашению не должно
                            рассматриваться как отказ этой стороны от
                            последующего понуждения к признанию своих прав или
                            совершению последующих действий в случае дальнейших
                            нарушений. 11. Государственное регулирование и
                            экспортный контроль. Приобретая и/или начиная
                            использовать Продукт, Вы обязуетесь соблюдать все
                            применимые международные и национальные законы,
                            которые распространяются на продукты, подлежащие
                            экспортному контролю. Настоящее ПО не должно
                            экспортироваться или реэкспортироваться в нарушение
                            экспортных ограничений, имеющихся в законодательстве
                            страны, в которой приобретено или получено ПО. Вы
                            также подтверждаете, что применимое законодательство
                            не запрещает Вам приобретать или получать ПО. 12.
                            Программное обеспечение третьих сторон. 12.1. Если
                            Продукт содержит в себе любое программное
                            обеспечение, предоставленное какой-либо третьей
                            стороной, такое программное обеспечение третьей
                            стороны предоставляется ”как есть” без какой-либо
                            гарантии, и разделы 2, 3, 6, 8, 9-12 настоящего
                            Соглашения применяются ко всем таким поставщикам
                            программного обеспечения и к поставляемому ими
                            программному обеспечению, как если бы это были и
                            Продукт соответственно. 12.2. This product includes
                            software developed by the OpenSSL Project for use in
                            the OpenSSL Toolkit (http://www.openssl.org/). 13.
                            Разное. 13.1. Настоящее Соглашение представляет
                            собой полное соглашение, относящееся к данной
                            лицензии, и может быть изменено только посредством
                            письменного соглашения, подписанного обеими
                            сторонами. Если выполнение какого-либо условия
                            настоящего Соглашения представляется невозможным,
                            такое условие будет скорректировано только в
                            пределах, обеспечивающих возможность выполнения
                            данного условия. 13.2. Все права на материалы, не
                            содержащиеся в ПО, но доступные посредством
                            использования ПО, принадлежат своим законным
                            владельцам и охраняются действующим
                            законодательством об авторском праве и
                            международными соглашениями. Настоящий Лицензионный
                            договор не предоставляет Вам никаких прав на
                            использование такой интеллектуальной собственности.
                            13.3. ПО содержит коммерческую тайну и иную
                            конфиденциальную информацию, принадлежащую Компании
                            и третьим лицам, которая охраняется действующим
                            законодательством Российской Федерации,
                            международными соглашениями и законодательством
                            страны приобретения и/или использования ПО. 13.4. Вы
                            соглашаетесь на добровольную передачу Компании в
                            процессе использования и регистрации ПО своих
                            персональных данных и выражаете свое согласие на
                            сбор, обработку, использование своих персональных
                            данных в соответствии с применимым
                            законодательством, на условиях обеспечения
                            конфиденциальности. Предоставленные Вами
                            персональные данные будут храниться и использоваться
                            только внутри Компании и ее дочерних компаний и не
                            будут предоставлены третьим лицам, за исключением
                            случаев, предусмотренных применимым
                            законодательством. 13.5. В случае предъявления любых
                            претензий или исков, связанных с использованием Вами
                            ПО Вы обязуетесь сообщить Компании Аладдин Р.Д. о
                            таких фактах в течение трех (3) дней с момента,
                            когда Вам стало известно об их возникновении. Вы
                            обязуетесь совершить необходимые действия для
                            предоставления Компании возможности участвовать в
                            рассмотрении таких претензий или исков, а также
                            предоставлять необходимую информацию для
                            урегулирования соответствующих претензий и/или исков
                            в течение семи (7) дней с даты получения запроса от
                            Компании 13.6. Вознаграждением по настоящему
                            Лицензионному договору признается стоимость Лицензии
                            на ПО, установленная Компанией или Партнером
                            Компании , которая, подлежит уплате в соответствии с
                            определяемым Компанией Аладдин Р.Д. или Партнером
                            Компании порядком. Вознаграждение также может быть
                            включено в стоимость приобретенного Вами
                            оборудования или в стоимость полной версии ПО. В
                            случае если Вы являетесь физическим лицом, настоящий
                            Лицензионный договор может быть безвозмездным. 13.7.
                            В случае если какая-либо часть настоящего
                            Лицензионного договора будет признана утратившей
                            юридическую силу (недействительной) и не подлежащей
                            исполнению, остальные части Лицензионного договора
                            сохраняют свою юридическую силу и подлежат
                            исполнению. Я прочитал и понял настоящее
                            лицензионное соглашение и согласен выполнять все его
                            условия. Я принимаю данное лицензионное соглашение
                            целиком. Если я не принимаю это лицензионное
                            соглашение или хотя бы один из его пунктов, то
                            данное лицензионное соглашение не вступает в силу, и
                            я обязуюсь не устанавливать и не использовать данное
                            программное обеспечение
                          </Typography>
                        </Box>
                      </Modal>
                    </div>
                  </label>
                </div>
              </form>
              <div className={styles.pos1440} onClick={handleRegister}>
                Пройти инициацию
              </div>
            </div>
          }
        />
      </div>
      <div className={styles.bigbutton} onClick={handleRegister}>
        пройти инициацию
      </div>
    </section>
  );
};

export default observer(RegisterPage);
